import React, { useState } from 'react';
import { X, Wallet, Trophy, Maximize2, LogOut, LogIn, Mail, Lock, User, Loader2 } from 'lucide-react';

const BRAND_COLOR = '#F82C47';
const LOGO_URL = 'https://customer-assets.emergentagent.com/job_pixel-perfect-432/artifacts/mvgdp67a_LOGO_CLUBBERS_PNG.png';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ProfileScreen = ({ isOpen, onClose, userData, onLogout, isLoggedIn, onLogin }) => {
  const [showAuth, setShowAuth] = useState(false);
  const [isRegister, setIsRegister] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const endpoint = isRegister ? `${API}/auth/register` : `${API}/auth/login`;
      const body = isRegister ? { name, email, password } : { email, password };
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Error en la autenticación');
      localStorage.setItem('auth_token', data.token);
      localStorage.setItem('user_id', data.user_id);
      localStorage.setItem('user_name', data.name);
      onLogin(data);
      setShowAuth(false);
      setName(''); setEmail(''); setPassword('');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Auth form inline
  if (showAuth) {
    return (
      <div className="fixed inset-0 z-[100] bg-[#0a0a0a] overflow-y-auto">
        <div className="px-5 pt-8 pb-6">
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-white text-3xl font-bold" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", system-ui, sans-serif' }}>
              {isRegister ? 'Crear cuenta' : 'Iniciar sesión'}
            </h1>
            <button onClick={() => setShowAuth(false)} className="glass-dark w-9 h-9 rounded-full flex items-center justify-center text-white">
              <X size={18} />
            </button>
          </div>
          <p className="text-gray-400 text-sm mb-8">
            {isRegister ? 'Crea tu cuenta para acumular puntos con cada compra' : 'Inicia sesión para acumular puntos'}
          </p>
          <form onSubmit={handleSubmit} className="space-y-4">
            {isRegister && (
              <div>
                <label className="text-gray-400 text-xs mb-1 block">Nombre</label>
                <div className="glass relative rounded-full">
                  <User size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/60" />
                  <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Tu nombre" required
                    className="w-full bg-transparent border-none rounded-full pl-10 pr-4 py-3 text-white placeholder-white/50 outline-none" />
                </div>
              </div>
            )}
            <div>
              <label className="text-gray-400 text-xs mb-1 block">Email</label>
              <div className="glass relative rounded-full">
                <Mail size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/60" />
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@email.com" required
                  className="w-full bg-transparent border-none rounded-full pl-10 pr-4 py-3 text-white placeholder-white/50 outline-none" />
              </div>
            </div>
            <div>
              <label className="text-gray-400 text-xs mb-1 block">Contraseña</label>
              <div className="glass relative rounded-full">
                <Lock size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/60" />
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required minLength={4}
                  className="w-full bg-transparent border-none rounded-full pl-10 pr-4 py-3 text-white placeholder-white/50 outline-none" />
              </div>
            </div>
            {error && <p className="text-[#F82C47] text-sm text-center">{error}</p>}
            <button type="submit" disabled={loading}
              className="w-full py-4 rounded-full flex items-center justify-center gap-2 text-white font-bold text-lg disabled:opacity-60 mt-6"
              style={{ backgroundColor: '#F82C47' }}>
              {loading ? <Loader2 size={20} className="animate-spin" /> : null}
              {loading ? 'Cargando...' : isRegister ? 'Crear cuenta' : 'Iniciar sesión'}
            </button>
          </form>
          <div className="mt-6 text-center">
            <button onClick={() => { setIsRegister(!isRegister); setError(''); }} className="text-[#F82C47] text-sm font-medium">
              {isRegister ? '¿Ya tienes cuenta? Inicia sesión' : '¿No tienes cuenta? Regístrate'}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-[100] bg-[#0a0a0a] overflow-y-auto">
      {/* Header */}
      <div className="px-5 pt-8 pb-6">
        <div className="flex items-center justify-between mb-1">
          <h1 className="text-white text-3xl font-bold" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", system-ui, sans-serif' }}>
            Mi Tarjeta
          </h1>
          <button onClick={onClose} className="glass-dark w-9 h-9 rounded-full flex items-center justify-center text-white">
            <X size={18} />
          </button>
        </div>
        <p className="text-gray-400 text-sm">Toca la tarjeta para ver más detalles</p>
      </div>

      {/* Card */}
      <div className="px-5 mb-4">
        <div className="rounded-2xl p-6 relative overflow-hidden" style={{ backgroundColor: '#F82C47' }}>
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center gap-2">
              <img src={LOGO_URL} alt="Clubbers" className="w-7 h-7 object-contain" style={{ filter: 'brightness(0)' }} />
              <span className="text-black font-bold text-lg" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", system-ui, sans-serif' }}>
                CLUBBERS MEMBER
              </span>
            </div>
            <div className="bg-black/20 rounded-full px-4 py-1.5">
              <span className="text-white font-bold text-sm">{userData.tier}</span>
            </div>
          </div>
          <div className="w-12 h-9 bg-black/10 rounded-lg flex items-center justify-center mb-6 border border-black/10">
            <div className="space-y-0.5">
              <div className="w-6 h-0.5 bg-black/40 rounded"></div>
              <div className="w-6 h-0.5 bg-black/40 rounded"></div>
              <div className="w-6 h-0.5 bg-black/40 rounded"></div>
            </div>
          </div>
          <div className="mb-6">
            <span className="text-black text-xl tracking-[0.3em] font-mono">•••• •••• •••• ac03</span>
          </div>
          <div className="flex items-end justify-between">
            <div>
              <span className="text-black/60 text-xs font-bold tracking-wider block">MIEMBRO</span>
              <span className="text-black font-bold text-lg">{userData.name ? userData.name.toUpperCase() : 'USUARIO'}</span>
            </div>
            <div className="text-right">
              <span className="text-black/60 text-xs font-bold tracking-wider block">PUNTOS</span>
              <span className="text-black font-bold text-3xl">{userData.points}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center gap-2 mb-8">
        <Maximize2 size={16} className="text-gray-400" />
        <span className="text-gray-400 text-sm">Toca para ampliar</span>
      </div>

      {/* Stats */}
      <div className="px-5 grid grid-cols-2 gap-4 mb-8">
        <div className="glass rounded-2xl p-5 flex flex-col items-center">
          <Wallet size={24} style={{ color: BRAND_COLOR }} className="mb-3" />
          <span className="text-white text-3xl font-bold mb-1">{userData.points}</span>
          <span className="text-gray-400 text-sm">Puntos Disponibles</span>
        </div>
        <div className="glass rounded-2xl p-5 flex flex-col items-center">
          <Trophy size={24} style={{ color: BRAND_COLOR }} className="mb-3" />
          <span className="text-white text-3xl font-bold mb-1">{(userData.total_points || 0).toLocaleString('es-ES')}</span>
          <span className="text-gray-400 text-sm">Puntos Totales</span>
        </div>
      </div>

      {/* Points info */}
      <div className="px-5 mb-6">
        <div className="glass rounded-2xl p-4">
          <p className="text-gray-400 text-sm">
            <span className="text-[#F82C47] font-bold">10 puntos</span> por cada <span className="text-white font-bold">1€</span> gastado
          </p>
        </div>
      </div>

      {/* Login prompt or Logout */}
      <div className="px-5 pb-8">
        {isLoggedIn ? (
          <button
            onClick={() => { onLogout(); onClose(); }}
            className="glass w-full py-3 rounded-full flex items-center justify-center gap-2 text-white font-bold transition-transform active:scale-[0.98]"
          >
            <LogOut size={18} />
            Cerrar sesión
          </button>
        ) : (
          <div className="space-y-3">
            <p className="text-gray-400 text-sm text-center mb-2">Inicia sesión para acumular puntos con tus compras</p>
            <button
              onClick={() => setShowAuth(true)}
              className="w-full py-3 rounded-full flex items-center justify-center gap-2 text-white font-bold transition-transform active:scale-[0.98]"
              style={{ backgroundColor: '#F82C47' }}
            >
              <LogIn size={18} />
              Iniciar sesión / Registrarse
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileScreen;
